import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {actions} from "~/state/reducers/deployment-context-reducer.ts"
import Selectors from "~/state/selectors.ts";

const URL_REGEX = /^https?:\/\/[^/]+\/([^/]+)\/?#\/(?:tn\/)?(C\d+)\/?.*$/u;
const CNUM_REGEX = /^c[0-9]{5}$/i;

export function useDeploymentContext() {
    const dispatch = useDispatch();
    const location = useLocation();
    const storedCnum = useSelector(Selectors.getCustomerNumber);

    useEffect(() => {
        const url = window.location.href;
        const result = URL_REGEX.exec(url);

        if (!result) {
            return;
        }
        const [
            unused,
            ctx,
            cnum,
        ] = result;

        if (storedCnum !== '') {
            return;
        }

        if (CNUM_REGEX.test(cnum)) {
            const serverBase = `${window.location.origin}/${ctx.split('-')[0]}/c/${cnum}/api`;
            dispatch(actions.setDeploymentContext({
                cnum: cnum,
                ctx: ctx,
                serverBase: serverBase,
                error: ''
            }));
        } else {
            dispatch(actions.setDeploymentContext({
                cnum: '',
                ctx: ctx,
                serverBase: '',
                error: 'Invalid cnum'
            }));
        }

    }, [dispatch, location]);
}

